// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pumpkaboo_average: PokeData = {
  "id": 710,
  "name": "pumpkaboo-average",
  "height": 4,
  "weight": 50,
  "base_experience": 67,
  "types": [
    PokeType.GHOST,
    PokeType.GRASS
  ],
  "api_moves": [
    "leech-seed",
    "razor-leaf",
    "confuse-ray",
    "scary-face",
    "pain-split",
    "shadow-ball",
    "trick",
    "astonish",
    "bullet-seed",
    "worry-seed",
    "seed-bomb",
    "shadow-sneak",
    "trick-or-treat"
  ],
  "moves": [
    "razor-leaf",
    "confuse-ray",
    "scary-face",
    "shadow-ball",
    "bullet-seed",
    "shadow-sneak",
    "wood-hammer",
    "leaf-tornado",
    "vine-whip",
    "solar-beam",
    "synthesis",
    "shadow-dagger",
    "night-shade"
  ],
  "evolution_chain": {
    "id": 365,
    "item": null,
    "species": [
      {
        "name": "pumpkaboo",
        "order": 710,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gourgeist",
        "order": 711,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 710,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55.75,
    "speed": 51,
    "ability_power": 66
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
